import {
  createClearType,
  createErrorType,
  createLoadingType,
  createSubmitType,
  createSuccessType,
} from '../actionHelpers';

// CRM event buy button clicked
const EVENT_BUY_BUTTON_CLICKED_SCOPE = 'EVENT_BUY_BUTTON_CLICKED_SCOPE';
export const EVENT_BUY_BUTTON_CLICKED = createSubmitType(
  EVENT_BUY_BUTTON_CLICKED_SCOPE,
);
export const EVENT_BUY_BUTTON_CLICKED_LOADING = createLoadingType(
  EVENT_BUY_BUTTON_CLICKED_SCOPE,
);
export const EVENT_BUY_BUTTON_CLICKED_SUCCESS = createSuccessType(
  EVENT_BUY_BUTTON_CLICKED_SCOPE,
);
export const EVENT_BUY_BUTTON_CLICKED_ERROR = createErrorType(
  EVENT_BUY_BUTTON_CLICKED_SCOPE,
);
export const EVENT_BUY_BUTTON_CLICKED_EMPTY = createClearType(
  EVENT_BUY_BUTTON_CLICKED_SCOPE,
);

// CRM event buy flow steps
const EVENT_BUY_STEP_SCOPE = 'EVENT_BUY_STEP_SCOPE';
export const EVENT_BUY_STEP = createSubmitType(EVENT_BUY_STEP_SCOPE);
export const EVENT_BUY_STEP_LOADING = createLoadingType(EVENT_BUY_STEP_SCOPE);
export const EVENT_BUY_STEP_SUCCESS = createSuccessType(EVENT_BUY_STEP_SCOPE);
export const EVENT_BUY_STEP_ERROR = createErrorType(EVENT_BUY_STEP_SCOPE);
export const EVENT_BUY_STEP_EMPTY = createClearType(EVENT_BUY_STEP_SCOPE);

// CRM general events
const CRM_EVENT_SCOPE = 'CRM_EVENT_SCOPE';
export const CRM_EVENT = createSubmitType(CRM_EVENT_SCOPE);
export const CRM_EVENT_LOADING = createLoadingType(CRM_EVENT_SCOPE);
export const CRM_EVENT_SUCCESS = createSuccessType(CRM_EVENT_SCOPE);
export const CRM_EVENT_ERROR = createErrorType(CRM_EVENT_SCOPE);
export const CRM_EVENT_EMPTY = createClearType(CRM_EVENT_SCOPE);

// CRM event mail-in storage started
const CRM_EVENT_MAIL_IN_STORAGE_STARTED_SCOPE =
  'CRM_EVENT_MAIL_IN_STORAGE_STARTED_SCOPE';
export const CRM_EVENT_MAIL_IN_STORAGE_STARTED = createSubmitType(
  CRM_EVENT_MAIL_IN_STORAGE_STARTED_SCOPE,
);
export const CRM_EVENT_MAIL_IN_STORAGE_STARTED_LOADING = createLoadingType(
  CRM_EVENT_MAIL_IN_STORAGE_STARTED_SCOPE,
);
export const CRM_EVENT_MAIL_IN_STORAGE_STARTED_SUCCESS = createSuccessType(
  CRM_EVENT_MAIL_IN_STORAGE_STARTED_SCOPE,
);
export const CRM_EVENT_MAIL_IN_STORAGE_STARTED_ERROR = createErrorType(
  CRM_EVENT_MAIL_IN_STORAGE_STARTED_SCOPE,
);

// CRM event SFH journey started
const SFH_JOURNEY_STARTED_SCOPE = 'SFH_JOURNEY_STARTED_SCOPE';
export const SFH_JOURNEY_STARTED = createSubmitType(SFH_JOURNEY_STARTED_SCOPE);
export const SFH_JOURNEY_STARTED_LOADING = createLoadingType(
  SFH_JOURNEY_STARTED_SCOPE,
);
export const SFH_JOURNEY_STARTED_SUCCESS = createSuccessType(
  SFH_JOURNEY_STARTED_SCOPE,
);
export const SFH_JOURNEY_STARTED_ERROR = createErrorType(
  SFH_JOURNEY_STARTED_SCOPE,
);
